import { render, staticRenderFns } from "./GenericReviewSpoilerCard.vue?vue&type=template&id=2b9c692d&scoped=true"
import script from "./GenericReviewSpoilerCard.vue?vue&type=script&lang=js"
export * from "./GenericReviewSpoilerCard.vue?vue&type=script&lang=js"
import style0 from "./GenericReviewSpoilerCard.vue?vue&type=style&index=0&id=2b9c692d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9c692d",
  null
  
)

export default component.exports